import useTranslation from '@/utils/hooks/translation/useTranslation';

import Icon from '@/components/base/Icon';

type BackButtonProps = { onClick: () => void };

export function BackButton({ onClick }: BackButtonProps) {
    const { t } = useTranslation('commons');
    return (
        <button
            onClick={onClick}
            className="flex w-max items-center gap-1 text-xs focus:ring-0 focus:ring-offset-0"
            data-testid="back-button">
            <Icon icon="arrow-left" />
            <span>{t('back')}</span>
        </button>
    );
}
